/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';
import { candidateSchema } from './candidate-schema';
import { userSchema } from './user-schema';

export const candidateWhiteboardSchema: z.AnyZodObject = z.object({
  body: z.string().nullish(),
  candidate: z.lazy(() => candidateSchema).nullish(),
  candidateId: z.string().uuid().nullish(),
  createdAt: z.string().datetime().nullish(),
  id: z.string().uuid(),
  lastUpdatedBy: z.string().uuid().nullish(),
  updatedAt: z.string().datetime().nullish(),
  updatedByUser: z.lazy(() => userSchema).nullish(),
});

export type CandidateWhiteboard = z.infer<typeof candidateWhiteboardSchema>;
